import React from "react";
import { CalendarCheck, Stethoscope, FlaskConical, ClipboardList } from "lucide-react";
import { howItWorks } from "../mock";

const ICONS = [CalendarCheck, Stethoscope, FlaskConical, ClipboardList];

export default function HowItWorks() {
  return (
    <section className="relative px-4 md:px-8 pb-4">
      <div className="relative mx-auto max-w-[1400px] rounded-[36px] bg-[#1a2464] text-white overflow-hidden">
        <div className="absolute inset-0 wave-pattern opacity-70 pointer-events-none" />
        <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-[#3dc9b3]/10 blur-3xl" />

        <div className="relative p-8 md:p-14 lg:p-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-end mb-14">
            <div>
              <span className="text-[#3dc9b3] font-semibold text-sm mb-3 inline-block">How It Works</span>
              <h2 className="text-4xl md:text-5xl lg:text-[3.2rem] font-bold leading-[1.1] tracking-tight">
                Your visit to<br />Beaudesert General Practice
              </h2>
            </div>
            <p className="text-white/75 leading-relaxed max-w-lg lg:ml-auto">
              We've made the process as simple and stress-free as possible. From booking to follow-up, our experienced doctors guide you through every step — all under one roof.
            </p>
          </div>

          {/* Steps - staggered layout */}
          <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {howItWorks.map((step, i) => {
              const Icon = ICONS[i];
              return (
                <div
                  key={step.step}
                  className={`relative rounded-2xl border border-white/15 p-6 md:p-7 bg-white/[0.02] hover:bg-white/[0.05] transition-colors ${
                    i % 2 === 1 ? "lg:translate-y-10" : ""
                  }`}
                >
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-14 h-14 rounded-xl bg-white/5 grid place-items-center">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <span className="text-[#3dc9b3] font-bold text-lg border-2 border-[#3dc9b3] rounded-full w-11 h-11 grid place-items-center">
                      {step.step}
                    </span>
                  </div>
                  <h3 className="text-white font-bold text-lg mb-3 leading-tight">{step.title}</h3>
                  <p className="text-white/70 text-sm leading-relaxed">{step.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
